import React from 'react';

const ScrollToTopButton = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // for smooth scrolling
    });
  };

  return (
    <button onClick={scrollToTop} style={buttonStyle}>
      <img src="/icons/up.svg" alt="up-icon" className='h-[24px]' />
    </button>
  );
};

const buttonStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    width: '3em',
    height: '3em',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '100%',
    backgroundColor: 'rgba(12, 26, 35, 0.2)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: 'none',
    cursor: 'pointer',
    color: '#fff',
    fontSize: '16px'
};

export default ScrollToTopButton;
